import apiClient from './api';
import { showToast } from '../utils/toast';

export interface FeedbackData {
  rating: number;
  category: string;
  details: string;
}

export const feedbackService = {
  /**
   * Submit user feedback to the backend API
   */
  async submitFeedback(data: FeedbackData): Promise<void> {
    try {
      // Send feedback to the backend
      // Authorization and x-tenant-id headers are automatically added by the apiClient interceptor
      await apiClient.post('/feedback', data);

      // Show success message
      showToast.success('Thank you for your feedback! It helps us improve.');
    } catch (error: any) {
      console.error('[FeedbackService] Submission failed:', error);
      const message = error?.response?.data?.message || 'Failed to submit feedback. Please try again later.';
      showToast.error(message);
      throw error;
    }
  },
};
